import { TTableStructureFilter } from '../../ui/EasTable/types';

export enum EEmStatus {
	ACTIVE = 'Active',
	DEACTIVATED = 'Deactivated',
	BLOCKED = 'Blocked',
	INACTIVE = 'Inactive',
}

export enum EActiveSerrvicesKeys {
	PPWR = 'ppwr',
	IOSS = 'IOSS',
	OSS = 'OSS',
	NON_UNION = 'NON UNION',
	SWISS = 'SWISS',
	GB = 'GB',
	GPSR = 'GPSR',
	EUDR = 'EUDR',
	EU_DDP = 'EU DDP',
}

export enum EActiveSerrvicesNames {
	PPWR = 'PPWR',
	IOSS = 'IOSS',
	OSS = 'OSS Union',
	NON_UNION = 'Non-Union',
	SWISS = 'Swiss',
	GB = 'GB',
	GPSR = 'GPSR',
	EUDR = 'EUDR',
	EU_DDP = 'EU DDP',
}

export const ACTIVE_SERVICES_FILTER_OPTIONS: TTableStructureFilter = [
	[EActiveSerrvicesKeys.IOSS, EActiveSerrvicesNames.IOSS],
	[EActiveSerrvicesKeys.OSS, EActiveSerrvicesNames.OSS],
	[EActiveSerrvicesKeys.NON_UNION, EActiveSerrvicesNames.NON_UNION],
	[EActiveSerrvicesKeys.SWISS, EActiveSerrvicesNames.SWISS],
	[EActiveSerrvicesKeys.GB, EActiveSerrvicesNames.GB],
	[EActiveSerrvicesKeys.GPSR, EActiveSerrvicesNames.GPSR],
	[EActiveSerrvicesKeys.EUDR, EActiveSerrvicesNames.EUDR],
	[EActiveSerrvicesKeys.EU_DDP, EActiveSerrvicesNames.EU_DDP],
	[EActiveSerrvicesKeys.PPWR, EActiveSerrvicesNames.PPWR],
];
